<template>
  <div></div>
</template>

<script>
import store from "@/store/index";
export default {
  components: {},
  data() {},
  created() {
    store().commit("setLogin", "");
    localStorage.removeItem("userBaseInfo");
    window.location.href = "/";
  },
};
</script>
